module.exports = __webpack_public_path__ + "img/191.97e1bd7b.svg";